// Material
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

// Components

import WrapperDatePicker from '../../../components/wrapperDatapicker';

// Hooks
import TerminalsDropdown from "./terminal";

const SettlementFilters = ({ filters, clearFilters, onFilterChange }) => {
  return (
    <Box component={Paper} padding={2}>
      <Grid container spacing={1}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 3
          }}
        >
          <Grid container spacing={1}>
            <Grid size={12}>
              <Typography variant="inherit" color="primary">
                {" "}
                Seleccionar Punto de Venta:{" "}
              </Typography>
            </Grid>
            <Grid size={12}>
              <TerminalsDropdown
                size="small"
                selected={filters.terminalId ? filters.terminalId : null}
                onChange={onFilterChange}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4
          }}
        >
          <Grid container spacing={1}>
            <Grid size={12}>
              <Typography
                variant="inherit"
                color="primary"
                style={{ display: "block" }}
              >
                {" "}
                Filtrar por fecha:{" "}
              </Typography>
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 6
              }}
            >

              <WrapperDatePicker
                filters={filters?.from}
                handleFilterChange={onFilterChange}
                type="from"
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 6
              }}
            >


              <WrapperDatePicker
                filters={filters?.to}
                handleFilterChange={onFilterChange}
                type="to"
              />
            </Grid>
          </Grid>
        </Grid>
        <Box
          component={Grid}
          item
          display="flex"
          flexGrow={1}
          alignItems="flex-end"
          justifyContent="flex-end"
        >
          <Button
            color="primary"
            variant="outlined"
            onClick={clearFilters}
            startIcon={<FilterListIcon />}
          >
            Limpiar
          </Button>
        </Box>
      </Grid>
    </Box>
  );
};

export default SettlementFilters;
